export const BOXREDUCER =  (state = { user_list: [],
  user_report_list: [],
  conversation_user: { id: 0 },
  conversation_report: { id: 0 },
  conversation_data: [],
  conversation_data_loading: false,
  conversation_popup_visible: false,
  attach_report_list: {},
  reports_to_attach: [],
  attach_popup_visible: false,
  attach_popup_loading: false,
  is_report_attaching: false,
  search_reports_result: [],
  template_list: [],
  template_id: 0,
  template_reports: [],
  selected_template_reports: [],
  scratch_reports: [],
  is_report_assigning: false
}, action) => {
  switch(action.type){
    case 'SET_USER_LIST':
      return {
        ...state,
        user_list: action.data
      }
    case 'SET_USER_REPORT_LIST':
      return {
        ...state,
        user_report_list: action.data
      }
    case 'SET_CONVERSATION_USER':
      return {
        ...state,
        conversation_user: action.data
      }
    case 'SET_CONVERSATION_REPORT':
      return {
        ...state,
        conversation_report: action.data
      }
    case 'SET_CONVERSATION_DATA':
      return {
        ...state,
        conversation_data: action.data
      }
    case 'TOGGLE_CONVERSATION_POPUP':
      return {
        ...state,
        conversation_popup_visible: action.data
      }
    case 'LOADING_CONVERSATION_DATA':
      return {
        ...state,
        conversation_data_loading: action.data
      }
    case 'SET_REPORT_FILES_LIST':
      return {
        ...state,
        attach_report_list: action.data
      }
    case 'TOGGLE_ATTACH_POPUP':
      return {
        ...state,
        attach_popup_visible: action.data
      }
    case 'SET_ATTACH_POPUP_LOADING':
      return {
        ...state,
        attach_popup_loading: action.data
      }
    case 'SET_IS_REPORT_ATTACHING':
      return {
        ...state,
        is_report_attaching: action.data
      }
    case 'SET_REPORT_SEARCH_RESULT':
      return {
        ...state,
        search_reports_result: action.data
      }
    case 'SET_REPORTS_TO_ATTACH':
      return {
        ...state,
        reports_to_attach: action.data
      }
    case 'SET_TEMPLATE_LIST':
      return {
        ...state,
        template_list: action.data
      }
    case 'SET_TEMPLATE_ID':
      return {
        ...state,
        template_id: action.data
      }
    case 'SET_TEMPLATE_REPORTS':
      return {
        ...state,
        template_reports: action.data
      }
    case 'SET_SELECTED_TEMPLATE_REPORTS':
      return {
        ...state,
        selected_template_reports: action.data
      }
    case 'SET_SCRATCH_REPORTS':
      return {
        ...state,
        scratch_reports: action.data
      }
    case 'SET_IS_REPORT_ASSIGNING':
      return {
        ...state,
        is_report_assigning: action.data
      }
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/redux/reducers/Box/BoxReducer.js